import React from "react";
import "./App.scss";
import { GameManager } from "./components/GameManager";

function App() {
    return (
        <div className="App">
            <GameManager />
        </div>
    );
}

export default App;
